import { Injectable } from '@angular/core';
import { Survey, SurveyQuestion } from '../Models/Survey';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/core/Services/shared.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()

export class SurveyService {

    constructor(private _http: HttpClient, private _shared: SharedService) {}

    // Parse date ISOString
    dateParse(dateStr: string): string {
        return dateStr.split('T')[0];
    }

    // Get survey list
    getSurveyList(): Promise<Survey[]> {
        return this._http.get<Survey[]>(`${this._shared.apiPath}RedBookSurvey/GetSurveyList`).pipe(catchError(this._shared.handleError)).toPromise();
    }
    
    // Get survey by id
    async getSurveyByID(SurveyID: number): Promise<Survey> {
        const SurveyList = await this.getSurveyList();
        return SurveyList.filter(s => s.SurveyID === SurveyID).shift();
        
        // return this._http.get<Survey>(`${this._shared.apiPath}RedBookSurvey/GetRedBookSurvey`).pipe(catchError(this._shared.handleError)).toPromise();
    }
    
    // Create new survey
    createNewSurvey(survey: Survey): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}RedBookSurvey/AddRedBookSurvey`, survey).pipe(catchError(this._shared.handleError));
    }

    // update survey
    updateSurvey(survey: Survey): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}RedBookSurvey/AddRedBookSurvey`, survey).pipe(catchError(this._shared.handleError));
    }
    
    updateQuestionOrder(SurveyQuestions: SurveyQuestion[]): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}RedBookSurvey/UpdateQuestionOrder`, SurveyQuestions).pipe(catchError(this._shared.handleError));
    }

    // Get quesionaire of survey
    getSurveyQuestions(SurveyID: number): Promise<SurveyQuestion[]> {
        return this._http.get<SurveyQuestion[]>(`${this._shared.apiPath}RedBookSurvey/GetQuestionListBySurvey?surveyID=${SurveyID}`).pipe(catchError(this._shared.handleError)).toPromise();
    }
    
    // Post question in a survey
    postSurveyQuestion(SurveyQuestion: SurveyQuestion): Promise<SurveyQuestion> {
        return this._http.post<SurveyQuestion>(`${this._shared.apiPath}RedBookSurvey/AddQuestion`, SurveyQuestion).pipe(catchError(this._shared.handleError)).toPromise();
    }
    
    // Delete question from a survey
    deleteSurveyQuestion(SurveyQuestionID: number): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}RedBookSurvey/DeleteQuestion?questionID=${SurveyQuestionID}`).pipe(catchError(this._shared.handleError));
    }

    // Download survey response excel
    getSurveyResponseExcel(SurveyID: number): string {
        return `${this._shared.apiPath}RedbookSurvey/GetSurveyForDownload?surveyID=${SurveyID}`;
    }
}